import { Link } from 'react-router-dom';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Settings, Link as LinkIcon } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

const navItemCls = (active) => (
  `px-4 py-2 text-sm font-medium transition-colors duration-200 flex items-center gap-2 ${
    active ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
  }`
);

export const DesktopNav = ({ user, navLinks, adminLinks, isActive }) => {
  const { t } = useLanguage();

  return (
    <nav className="hidden md:flex items-center gap-1">
      {navLinks.map(({ path, label, icon: Icon }) => (
        <Link key={path} to={path} className={navItemCls(isActive(path))}>
          <Icon className="w-4 h-4" />
          {label}
        </Link>
      ))}

      {user?.role === 'parent' && (
        <Link to="/link-student" className={navItemCls(isActive('/link-student'))}>
          <LinkIcon className="w-4 h-4" />
          {t('nav.linkChild')}
        </Link>
      )}

      {user?.role === 'admin' && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="text-sm font-medium flex items-center gap-2">
              <Settings className="w-4 h-4" />
              {t('nav.admin')}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48 bg-card border-border">
            {adminLinks.map(({ path, label, icon: Icon }) => (
              <DropdownMenuItem key={path} asChild>
                <Link to={path} className="flex items-center gap-2 cursor-pointer">
                  <Icon className="w-4 h-4" />
                  {label}
                </Link>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </nav>
  );
};
